let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hiDc4")).then(() => parcelRequire('2XGFW'));